export const DDNJ_PROPOSAL_INFO_FORM_ID = 'ddnj-proposal-info-form';
export const DDNJ_SIC_WARNING_ALERT_TEST_ID = 'ddnj-proposal-info-sic-warning-alert';
